module.exports = __webpack_public_path__ + "static/media/steelGates.57be395e.jpg";